/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseEntryStatisticViewRecord
 */
export interface DatabaseEntryStatisticViewRecord {
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryStatisticViewRecord
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseEntryStatisticViewRecord
     */
    timestamp?: Date;
    /**
     * true, wenn der Aufruf vom DB-Owner selbst kam (Vergleich
     * customer.id == database.customerId beim recordStatistic).
     * Historische Records haben das Flag nicht — Frontend nutzt dann
     * einen Email-Vergleich als Fallback.
     * @type {boolean}
     * @memberof DatabaseEntryStatisticViewRecord
     */
    byOwner?: boolean;
}

/**
 * Check if a given object implements the DatabaseEntryStatisticViewRecord interface.
 */
export function instanceOfDatabaseEntryStatisticViewRecord(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntryStatisticViewRecordFromJSON(json: any): DatabaseEntryStatisticViewRecord {
    return DatabaseEntryStatisticViewRecordFromJSONTyped(json, false);
}

export function DatabaseEntryStatisticViewRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryStatisticViewRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'timestamp': !exists(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
        'byOwner': !exists(json, 'byOwner') ? undefined : json['byOwner'],
    };
}

export function DatabaseEntryStatisticViewRecordToJSON(value?: DatabaseEntryStatisticViewRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
        'byOwner': value.byOwner,
    };
}

